<template>
  <Modal name="rollDice">
    <template v-slot:default="{ options }">
      <ModalCard>
        <template v-slot:title>{{ options.item.name }}</template>
        
        <div class="field has-addons has-addons-centered">
          <div class="control">
            <DiceRoll ref="diceRoller" :roll="roll" :character="character" :computed="computed" />
          </div>
        </div>
      
        <div class="field has-addons has-addons-centered">
          <div class="control">
            <a class="button is-primary" @click="rollDice">Roll</a>
          </div>
          <div v-if="bonuses.inspiration" class="control">
            <a :class="{ 'button': true, 'is-primary': useInspiration }" :disabled="options.removeInspiration" @click="useInspiration = !useInspiration">+1</a>
          </div>
        </div>

        <template v-if="options.item.roll.type === 'health' || options.item.bonus || options.item.requiresRested" v-slot:buttons>
          <div class="buttons has-addons">
            <button class="button is-primary" @click="openModal" :disabled="!outcomeValue">
              <template v-if="options.item.roll.type === 'health'">Apply Health to Self</template>
              <template v-else>Finish</template>
            </button>
          </div>
        </template>
      </ModalCard>
    </template>
  </Modal>
</template>

<script>
import { defineComponent, inject, ref, watch, nextTick } from 'vue'

import useModal from '@/hooks/useModal'

import Modal from '@/components/Modal'
import ModalCard from '@/components/ModalCard'
import DiceRoll from '@/components/DiceRoll'

export default defineComponent({
  components: {
    DiceRoll,
    Modal,
    ModalCard
  },

  setup (props, { emit }) {
    const character = inject('character')
    const computed = inject('computedCharacter')
    const appState = inject('appState')
    
    const { currentModal } = useModal()

    const outcomeValue = ref(null)
    const diceRoller = ref(null)
    const useInspiration = ref(false)
    const rollDice = () => {
      if (useInspiration.value && computed.bonuses.value.inspiration) {
        currentModal.value.options.onClose = () => {
          emit('removeInspiration')
        }
      } else {
        delete currentModal.value.options.onClose
      }

      if (appState.hardRolls) {
        outcomeValue.value = Math.abs(Number(prompt('What was the outcome of your roll?') || 0))
      } else {
        outcomeValue.value = diceRoller.value.rollDice().outcome
      }
    }

    const terminateModal = inject('terminateModal')
    const openModal = () => {
      const options = currentModal.value.options
      const item = options.item

      if (item.roll.type === 'health') {
        emit('applyHealth', outcomeValue.value)
      }

      terminateModal(null, options)
    }
    watch(currentModal, () => {
      outcomeValue.value = null
      useInspiration.value = false
    })

    const roll = ref(null)
    const makeRoll = (modal, inspired) => {
      if (!modal || modal.name !== 'rollDice') {
        return
      }

      const nextRoll = [ ...modal.options.item.roll.value ]
      if (modal.options.item.roll.type === 'health' && modal.options.item.level !== undefined && computed.bonuses.value.healing) nextRoll.push(computed.bonuses.value.healing)
      if (inspired) nextRoll.push('+1')
      roll.value = nextRoll
    }
    watch(currentModal, (modal) => makeRoll(modal, useInspiration.value))
    watch(useInspiration, (inspired) => makeRoll(currentModal.value, inspired))
    watch(outcomeValue, (value) => {
      if (!appState.hardRolls || typeof value !== 'number') return
      roll.value = [`+${value}`]
      nextTick(() => diceRoller.value.rollDice())
    })

    return {
      roll,
      character,
      computed,
      ...computed,
      openModal,
      terminateModal,
      diceRoller,
      rollDice,
      outcomeValue,
      useInspiration
    }
  }
})
</script>

<style lang="sass" scoped>
</style>
